/* Pelusa — interacciones (vanilla, sin librerías) */
(function () {
  if (window.__ncInit) return;
  window.__ncInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nc-reveal:not(.nc-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nc-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('nc-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* Hotspots */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-nc-hot]').forEach(function (sec) {
      if (sec.dataset.ncInit) return; sec.dataset.ncInit = '1';
      var items = sec.querySelectorAll('[data-hot-i]');
      function activar(i) {
        items.forEach(function (el) { el.classList.toggle('is-activo', el.getAttribute('data-hot-i') === String(i)); });
      }
      items.forEach(function (el) {
        var i = el.getAttribute('data-hot-i');
        el.addEventListener('mouseenter', function () { activar(i); });
        el.addEventListener('focus', function () { activar(i); });
        el.addEventListener('click', function () { activar(i); });
      });
      activar(1);
    });
  }

  /* Modos (slider de intensidad) */
  function initModos(root) {
    (root || document).querySelectorAll('[data-nc-modos]').forEach(function (sec) {
      if (sec.dataset.ncInit) return; sec.dataset.ncInit = '1';
      var rango = sec.querySelector('.nc-modos__rango');
      var tabs = sec.querySelectorAll('.nc-modos__tab');
      var txts = sec.querySelectorAll('.nc-modos__txt');
      var viz = sec.querySelector('.nc-modos__viz');
      var onda = sec.querySelector('.nc-modos__onda');
      var num = sec.querySelector('[data-modo-num]');
      var lbl = sec.querySelector('[data-modo-lbl]');
      var total = txts.length;
      if (!total) return;
      function ondaPath(amp, frec) {
        var d = 'M 40 165', x;
        for (x = 40; x <= 360; x += 4) {
          var t = (x - 40) / 320;
          var env = Math.sin(Math.PI * t);
          d += ' L ' + x + ' ' + (165 - Math.sin(t * Math.PI * 2 * frec) * amp * env).toFixed(1);
        }
        return d;
      }
      function set(i) {
        i = Math.max(0, Math.min(total - 1, i));
        txts.forEach(function (t, k) { t.classList.toggle('is-activo', k === i); });
        tabs.forEach(function (t, k) { t.classList.toggle('is-activo', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        var el = txts[i];
        var nivel = (i + 1) / total;
        if (rango) { rango.value = i; rango.style.setProperty('--p', (total > 1 ? i / (total - 1) * 100 : 100) + '%'); }
        if (viz) {
          viz.style.setProperty('--vel', (3.6 - nivel * 2.1).toFixed(2) + 's');
          viz.style.setProperty('--esc', (0.75 + nivel * 0.35).toFixed(2));
          viz.style.setProperty('--op', (0.25 + nivel * 0.45).toFixed(2));
        }
        if (onda) onda.setAttribute('d', ondaPath(18 + nivel * 52, 3 + nivel * 6));
        if (num) num.textContent = el.getAttribute('data-num') || '';
        if (lbl) lbl.textContent = el.getAttribute('data-lbl') || '';
      }
      if (rango) rango.addEventListener('input', function () { set(parseInt(rango.value, 10)); });
      tabs.forEach(function (t, k) { t.addEventListener('click', function () { set(k); }); });
      set(parseInt(sec.getAttribute('data-inicial') || '0', 10));
    });
  }

  /* FAQ */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-nc-faq]').forEach(function (sec) {
      if (sec.dataset.ncInit) return; sec.dataset.ncInit = '1';
      var unico = sec.getAttribute('data-unico') === 'true';
      sec.querySelectorAll('.nc-faq__item').forEach(function (item) {
        var b = item.querySelector('.nc-faq__q');
        b.addEventListener('click', function () {
          var abrir = !item.classList.contains('is-abierto');
          if (unico) sec.querySelectorAll('.nc-faq__item.is-abierto').forEach(function (o) { o.classList.remove('is-abierto'); o.querySelector('.nc-faq__q').setAttribute('aria-expanded', 'false'); });
          item.classList.toggle('is-abierto', abrir);
          b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        });
      });
    });
  }

  /* Producto: galería, variantes, cantidad */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var coma = v.replace('.', ',');
    if (!fmt) return coma + ' €';
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
              .replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }
  function initProducto(root) {
    (root || document).querySelectorAll('[data-nc-prod]').forEach(function (sec) {
      if (sec.dataset.ncInit) return; sec.dataset.ncInit = '1';
      var principal = sec.querySelector('.nc-prod__principal img');
      var video = sec.querySelector('.nc-prod__principal video');
      sec.querySelectorAll('.nc-prod__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          sec.querySelectorAll('.nc-prod__mini').forEach(function (o) { o.classList.remove('is-activo'); });
          m.classList.add('is-activo');
          if (m.hasAttribute('data-video')) { if (video) { video.hidden = false; video.play && video.play(); } if (principal) principal.hidden = true; return; }
          if (video) { video.hidden = true; video.pause && video.pause(); }
          if (principal) principal.hidden = false;
          if (principal) { principal.style.opacity = 0; setTimeout(function () { principal.src = m.getAttribute('data-src'); principal.srcset = ''; principal.style.opacity = 1; }, 180); }
        });
      });
      var cant = sec.querySelector('.nc-prod__cant input');
      sec.querySelectorAll('[data-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-cant'), 10));
          cant.value = v;
          sec.querySelectorAll('input[name="quantity"]').forEach(function (q) { q.value = v; });
        });
      });
      if (cant) cant.addEventListener('change', function () { sec.querySelectorAll('input[name="quantity"]').forEach(function (q) { q.value = Math.max(1, parseInt(cant.value, 10) || 1); }); });
      var dataEl = sec.querySelector('script[data-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var fmt = sec.getAttribute('data-money');
      var txtAdd = sec.getAttribute('data-txt-add'), txtAgot = sec.getAttribute('data-txt-agotado');
      function actualizar() {
        var sel = [];
        sec.querySelectorAll('.nc-prod__opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
        var botones = sec.querySelectorAll('[data-nc-add]');
        if (!v) { botones.forEach(function (b) { b.disabled = true; }); return; }
        sec.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = v.id; });
        var p = sec.querySelector('[data-precio]'); if (p) p.textContent = money(v.price, fmt);
        var c = sec.querySelector('[data-comparar]');
        var ah = sec.querySelector('[data-ahorro]');
        if (c) { if (v.compare_at_price && v.compare_at_price > v.price) { c.textContent = money(v.compare_at_price, fmt); c.hidden = false; if (ah) { ah.hidden = false; ah.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; } } else { c.hidden = true; if (ah) ah.hidden = true; } }
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var t = b.querySelector('[data-label]');
          if (t && b.hasAttribute('data-principal')) t.textContent = v.available ? txtAdd : txtAgot;
        });
        if (v.featured_image && principal) { principal.src = v.featured_image; principal.srcset = ''; }
        if (window.history && window.history.replaceState && sec.getAttribute('data-url')) {
          window.history.replaceState({}, '', sec.getAttribute('data-url') + '?variant=' + v.id);
        }
      }
      sec.querySelectorAll('.nc-prod__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveal(root); initHotspots(root); initModos(root); initFaq(root); initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
